// material
import React, { useEffect, useState } from "react";
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { subDays } from 'date-fns'

import {
  Box, Grid,
  Container, Button, Typography, Card,
  Popover, Stack, Tab, IconButton, MenuList, MenuItem
} from '@mui/material';

import { TabContext, TabPanel, TabList } from '@mui/lab';

import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import { makeStyles } from '@mui/styles';
import { createTheme } from "@mui/material/styles";
import axios from 'axios';

import { APP_CONSTANTS } from "../URLConstants";

import { GetOrganizationMerchantStats, GetOrganizationTransactionStats, GetAllOrganinazations } from "../network/Organization";

import { getDateINYMD, getDateInddMMYYYY } from '../utils/formatTime';
import AlertDialog from "../components/AlertDialog";
import { useAuth } from "../components/customContextProviders/AuthContext";

// components
import Page from '../components/Page';
import { DateRangePickerDialog } from '../components/_dashboard/app';

import {
  SoundBoxDevicesStats, SoundBoxStatsItem, NewDeviceRequestFormModal, DeviceOrderdButtons
} from '../components/_dashboard/soundbox';

import SoundBoxTransactions from "./SoundBoxTransactions";



const useStyles = makeStyles({
  hidden: {
    display: "none !important"
  },
  show: {
    display: "block !important"
  },
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "120px",
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
    marginBottom: '10px'
  },
  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    maxHeight: '800px',
    marginRight: "3px",
    width: "100%",
    minWidth: "100%",

  },
  backGroundRed: {
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite: {
    background: 'white'
  },
  root: {
    flexGrow: 1,
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});




export default function SoundBoxDashboard() {

  const classes = useStyles();
  const navigate = useNavigate();
  const { user } = useAuth()
  const { sessionUserData, audioCubeAppLevelSettings } = useAuth()
  const [transactionStatsData, setTransactionStatsData] = useState({data:{}, loading:false})
  const [isDateRangeDialogOpen, setIsDateRangeDialogOpen] = useState(false)
  const [customDateSelectedString, setCustomDateSelectedString] = useState("")
  const [isUpdatedDeviceModal, setIsUpdatedDeviceModal] = useState(false);
  const [isDeviceRequestModalOpen, setIsDeviceRequestModalOpen] = useState(false);

  const [requestDeviceAnchorEl, setRequestDeviceAnchorEl] = useState(null);
  const [exportDataAnchorEl, setExportDataAnchorEl] = useState(null);

  const requestDeviceDropdowOpen = Boolean(requestDeviceAnchorEl);
  const exportDataeDropdowOpen = Boolean(exportDataAnchorEl);

  const requestDeviceDropdownId = requestDeviceDropdowOpen ? 'requestDevice-popover' : undefined;
  const exportDataDropdownId = exportDataeDropdowOpen ? 'exportData-popover' : undefined;

  const [statsActive, setStatsActive] = useState("1")


  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });
  const [soundboxStatsData, setSoundboxStatsData] = useState({});

  const [allOrganizationList, setAllOrganizationList] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [organization, setOrganization] = useState({orgId: "dcaf2f5c-f829-402e-9051-17357ce03881", orgName: "Bank Of Baroda"});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectOrganization = (id, name) => {
    setOrganization(_organization=> ({
      orgId: id,
      orgName: name
    }))
    handleClose(); // Close the dropdown after selection
  };

  const organizationDropDown = Boolean(anchorEl);
  const id = organizationDropDown ? "organization-popover" : undefined;




  useEffect(() => {
    const source = axios.CancelToken.source();

    if (sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN) {
      getAllOrganinazationList();
    }

    getDashboardDeviceStats(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? organization?.orgId : sessionUserData?.user?.organization?.id)
    getTransactionStats(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? organization?.orgId : sessionUserData?.user?.organization?.id, getDateINYMD(new Date()), getDateINYMD(new Date()), sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? { cancelToken: source.token }: {})

    return () => {

    }
  }, [organization?.orgId]);
  

  const handleStatsTabChange = (_event, newValue) => {
    setTransactionStatsData({})
    if (newValue === '1')
      getTransactionStats(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, getDateINYMD(new Date()), getDateINYMD(new Date()))
    else if (newValue === '2')
      getTransactionStats(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, getDateINYMD(subDays(new Date(), 30)), getDateINYMD(new Date()))
    else if (newValue === '3')
      setIsDateRangeDialogOpen(true)

    setStatsActive(newValue);
  };

  function getAllOrganinazationList(){

    GetAllOrganinazations(1, 100).then((res) => {
      setAllOrganizationList(res?.data?.data)
    }).catch((_error) => {
    })
  }


  function getDashboardDeviceStats(organizationId) {
    GetOrganizationMerchantStats(organizationId).then((res) => {
      setSoundboxStatsData(res?.data?.data)
    }).catch((_error) => {

    })
  }


  function onDateRangeSelectedAction(fromDate, todate) {

    if (fromDate === undefined || todate === undefined || fromDate === null || todate === null) {
      setAlertDialogMetas({ ...alertDialogMetas, message: "Please select Date Range.", title: "", btnLabel: "OK" });
      setOpenAlertDialog(true)
      return false
    }

    setCustomDateSelectedString(getDateInddMMYYYY(fromDate).concat(' -to- ').concat(getDateInddMMYYYY(todate)))
    getTransactionStats(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, getDateINYMD(fromDate), getDateINYMD(todate))

  }

  function getTransactionStats(organizationId, fromDate, toDate) {
    
    setTransactionStatsData(transactionStatsData => ({
      ...transactionStatsData,
      data: {},
      loading: true
    }))


    GetOrganizationTransactionStats(organizationId, fromDate, toDate).then((res) => {
      setTransactionStatsData(_transactionStatsData => res?.data?.data)

      setTransactionStatsData(transactionStatsData => ({
        ...transactionStatsData,
        data: res?.data?.data,
        loading: false
      }))
    }).catch((_error) => {

    })


    // GetDevicePaymentStats(fromDate,toDate,{}).then((res)=>{

    //   setTransactionStatsData(transactionStatsData => ({
    //     ...transactionStatsData,
    //     data: res?.data?.data,
    //     loading: false
    //   }))

    // }).catch((err)=>{
    //   setTransactionStatsData(transactionStatsData => ({
    //     ...transactionStatsData,
    //     loading: false
    //   }))
    // })

  }



  function onNewDeviceRequestModalAction(d) {
    alert(d)
  }

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,    
        sm: 768,  
        md: 1024, 
        lg: 1280, 
        xl: 390,  
      },
    },
  });






  return (
    <Page title="AudioCube">
      <Container maxWidth="false">

        <Box >
          <Grid container direction={{md:"row", sm:"row", xs:"column"}} display="flex" gap={{md:2, xs:0.5}} alignItems={{md:"center", xs:"flex-start"}}>
          <DeviceOrderdButtons />
          {
            sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN ?
          <Button variant="contained" color="whitebg" data-testid='organization' endIcon={<KeyboardArrowDownRoundedIcon />} size="small" sx={{ mr: 1, minHeight: '5vh', minWidth: 110, mt:1}} 
          onClick={handleClick} 
          >{organization?.orgName}</Button>
          :
          null
          }
          <Popover
              id={id}
              open={organizationDropDown}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              data-testid = 'organization-drop-down'
            >
              <MenuList>
                {allOrganizationList.map((org) => (
                  <MenuItem
                    key={org.id}
                    onClick={() => 
                      handleSelectOrganization(org.id, org.name)
                    }
                  >
                    {org.name}
                  </MenuItem>
                ))}
              </MenuList>
            </Popover>
  
          </Grid>

        </Box>



        <Grid container spacing={1} mb={1} direction={{xs:'column', sm:'column', md: 'row'}}>
          <Grid item xs={12} sm={6} md={9}>
            <SoundBoxDevicesStats admindashboardData={soundboxStatsData} />
          </Grid>


          <Grid item xs={12} sm={6} md={3} mb={1} >
            <Card sx={{
              height: '100%', background: "#FFFFFF",
              boxShadow: "10px 10px 19px 1px #EAEAFF",
              borderRadius: "20px",
            }}>

              <Stack
                direction="column"
                justifyContent="center"
                alignItems={{xs: "flex-start", sm:'center', md:"flex-start"}}
                spacing={{xs:0.5, md:1}}
                p={{xs:1, md:1}}
                ml={2}
                sx={{ height: '100%' }}
                >

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left', minWidth: '30%' }}>
                  <Typography sx={{ fontWeight: 700, color: "#0DA626", pr: 1, fontSize: "14px", lineHeight: "18px", }}>In Stock : </Typography>
                  <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px" }}>{soundboxStatsData?.device_inventory_stats?.inStock}</Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '30%' }}>
                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", pr: 1, fontSize: "14px", lineHeight: "18px" }}>In Production : </Typography>
                  <Typography sx={{ fontWeight: 700, color: "#171D40", opacity: "0.6", fontSize: "18px", lineHeight: "23px" }}>{soundboxStatsData?.device_inventory_stats?.InProduction}</Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>


        {
          sessionUserData?.user?.role !== APP_CONSTANTS.L1_SUPPORT_USER_ROLE ?
            <Grid container spacing={3} mb={2} >
              <Grid item xs={12} sm={12} md={12}>
                <Card sx={{
                  height: '100%', background: "#FFFFFF",
                  boxShadow: "10px 10px 19px 1px #EAEAFF",
                  borderRadius: "20px",
                }}>

                  <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={statsActive}>

                      <TabList sx={{
                        '& .MuiTabs-flexContainer': {
                          justifyContent: 'center'
                        }
                      }} onChange={handleStatsTabChange} aria-label="transaction_stats_tab">
                        <Tab label="Day" value="1" />
                        <Tab label="Month" value="2" />
                        <Tab iconPosition="end"
                          label={
                            <div>
                              <Stack direction="row" spacing={1}>
                                <Typography sx={{ fontSize: 14, fontWeight: 700 }}> Custom Date </Typography>
                                <Typography sx={{ fontSize: 14, fontWeight: 700, backgroundColor: '#C6FFCF', borderRadius: 8 }}> {customDateSelectedString}</Typography>
                                {
                                  customDateSelectedString !== '' ?
                                    <IconButton size="small" color="error" onClick={() => { setCustomDateSelectedString(""); setIsDateRangeDialogOpen(true) }} sx={{ p: 0 }}>
                                      <CloseOutlinedIcon sx={{ fontSize: 24 }} />
                                    </IconButton>
                                    :
                                    null
                                }
                              </Stack>
                            </div>
                          }

                          value="3" />
                      </TabList>
                      <TabPanel value="1">
                        <SoundBoxStatsItem statsData={transactionStatsData?.data} loading = {transactionStatsData?.loading} />
                      </TabPanel>
                      <TabPanel value="2">
                        <SoundBoxStatsItem statsData={transactionStatsData?.data} loading = {transactionStatsData?.loading} />
                      </TabPanel>
                      <TabPanel value="3">
                        <SoundBoxStatsItem statsData={transactionStatsData?.data} loading = {transactionStatsData?.loading} />
                      </TabPanel>
                    </TabContext>
                  </Box>



                </Card>
              </Grid>
            </Grid>
            :
            null
        }


        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <SoundBoxTransactions organizationId={organization?.orgId} soundboxDeviceListData={soundboxStatsData?.devices} />
            </Grid>


          </Grid>
        </Box>


        <NewDeviceRequestFormModal opneAssignedModal={isDeviceRequestModalOpen} handleClose={() => setIsDeviceRequestModalOpen(false)} onAction={(d) => onNewDeviceRequestModalAction(d)} />
        <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
          btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />

        <DateRangePickerDialog openDateRangeModal={isDateRangeDialogOpen} handleClose={() => setIsDateRangeDialogOpen(false)} onAction={(fromDate, toDate) => onDateRangeSelectedAction(fromDate, toDate)} />

      </Container>
    </Page >
  );
}
